import { motion } from "framer-motion";
import { Check } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    title: "THE MONEY",
    headline: "$250 a month. That's the whole fee.",
    points: ["Keep 85–95% of every commission", "No startup fees, ever", "No lock-in contract — leave anytime"],
  },
  {
    num: "02",
    title: "THE TOOLKIT",
    headline: "Every system you need, included.",
    points: ["Eagle CRM, set up and managed", "All major real estate portals", "DocuSign + full trust accounting"],
  },
  {
    num: "03",
    title: "THE TEAM",
    headline: "A back-end team, listing to settlement.",
    points: ["Dedicated support for every file", "Admin, compliance and processing handled", "You sell — we run everything behind you"],
  },
  {
    num: "04",
    title: "YOUR BRAND",
    headline: "Your name, ours, or both.",
    points: ["Operate under your own brand", "Or under Agency HQ's, or co-branded", "No brand? Our marketing team builds one free"],
  },
];

export default function Included() {
  return (
    <section data-testid="included-section" className="px-6 sm:px-10 lg:px-16 py-24 lg:py-32">
      <div className="max-w-6xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-[11px] uppercase tracking-[0.3em] text-[#555] mb-16"
        >
          What's included
        </motion.p>

        <div className="space-y-20 lg:space-y-28">
          {CHAPTERS.map((ch, idx) => (
            <motion.div
              key={ch.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="grid md:grid-cols-12 gap-6 md:gap-10 border-t border-[#111111]/10 pt-10"
              data-testid={`chapter-${ch.num}`}
            >
              <div className="md:col-span-4 flex md:flex-col gap-4 md:gap-2 items-baseline">
                <span className={`font-display font-semibold text-5xl lg:text-7xl tracking-tight ${idx === 0 ? "text-[#FF3B30]" : "text-outline"}`}>
                  {ch.num}
                </span>
                <span className="text-xs uppercase tracking-[0.3em] text-[#555]">{ch.title}</span>
              </div>
              <div className="md:col-span-8">
                <h2 className="font-display font-semibold tracking-tight text-base md:text-lg mb-6">{ch.headline}</h2>
                <ul className="space-y-3">
                  {ch.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm sm:text-base text-[#333]">
                      <Check size={16} strokeWidth={3} className="mt-1 shrink-0 text-[#FF3B30]" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
